class CadastroCodigoFornecedorModal {
    static get $inject() {
        return ['gql', '$scope', 'Produtos']
    }

    constructor(gql, $scope, Produtos) {
        this.gql = gql
        this.Produtos = Produtos
        this.apply = fun => $scope.$apply(fun)
        this.onClose = () => {
            this.close({ $value: this.produto.codigos })
        }
    }

    get codigosSugeridos() {
        return this.produto && this.produto.codigosSugeridos.reject((codigoSugerido) => codigoSugerido.utilizada)
    }

    $onInit() {
        this.promise = this
            .loadProduto()
            .then(produto => {
                this.produto = produto
                this.codigo = { codigo: produto.codigo }
            })
            .finally(() => this.apply())
    }

    loadProduto() {
        const query = gql`
            query CodigosFornecedores($filialId: String!, $produtoId: String!){
                filial(id: $filialId){
                    id
                    produto(id: $produtoId) {
                        id
                        codigo
                        codigosFornecedores {
                            id
                            codigoFornecedor
                            cnpjFornecedor
                            codigo
                        }
                        codigosFornecedoresSugeridos {
                            id
                            codigoFornecedor
                            cnpjFornecedor
                            utilizada
                        }
                    }
                }
            }
        `

        const { produtoId, filialId } = this.resolve

        return this.gql.query(query, { produtoId, filialId: parseInt(filialId) })
            .then(({ filial: { produto } }) => {
                const { codigo, codigosFornecedores, codigosFornecedoresSugeridos } = produto

                return {
                    ...produto,
                    codigos: codigosFornecedores.map(cf => ({ ...cf, codigo })),
                    codigosSugeridos: codigosFornecedoresSugeridos.map(cfs => ({ ...cfs, codigo }))
                }
            })
    }

    adicionar() {
        if (this.form.$valid) {
            this.cadastroCodigoFornecedor()
        }
    }

    adicionarFornecedor({ cnpjFornecedor, codigoFornecedor }) {
        this.codigo = { cnpjFornecedor, codigoFornecedor, codigo: this.produto.codigo }
        this.cadastroCodigoFornecedor()
    }

    cadastroCodigoFornecedor() {
        const { produtoId } = this.resolve

        this.formPromise = this.Produtos
            .createCodigoFornecedor(this.resolve.empresaId, produtoId, this.codigo)
            .then(codigo => {
                this.produto.codigos.push(codigo)
                this.codigo = { codigo: this.produto.codigo }
                this.form.$setPristine()
                this.findSugestaoAndChangeStatus(codigo, true)
            })
            .finally(() => this.apply())
    }

    removerCodigo(codigo) {
        codigo.promise = this.Produtos
            .deleteCodigoFornecedor(this.resolve.empresaId, codigo)
            .then(() => {
                this.produto.codigos = this.produto.codigos.reject(({ id }) => id === codigo.id)
                this.findSugestaoAndChangeStatus(codigo, false)
            })
            .finally(() => this.apply())
    }

    findSugestaoAndChangeStatus(codigo, status) {
        let sugestao = this.produto.codigosSugeridos.find(({ codigoFornecedor, cnpjFornecedor }) => {
            return (codigoFornecedor == codigo.codigoFornecedor) && (cnpjFornecedor == codigo.cnpjFornecedor)
        })

        if (sugestao) {
            sugestao.utilizada = status
        }
    }
}

angular.module("eficienciaFiscalModule")
    .component("cadastroCodigoFornecedorModal", {
        controller: CadastroCodigoFornecedorModal,
        bindings: {
            close: '&',
            resolve: '<',
            empresaId: '<'
        },
        template: `
        <form name="$ctrl.form" ng-submit="$ctrl.adicionar()" novalidate>
            <modal modal-title="Cadastro de código de fornecedor" close="$ctrl.onClose">
                <modal-body>
                    <loading promise="$ctrl.promise">
                        <div class="principal">
                            <div>
                                <div class="row">
                                    <div class="col-xs-5 form-group">
                                        <label>CNPJ do fornecedor</label>
                                        <input ui-br-cnpj-mask ng-model="$ctrl.codigo.cnpjFornecedor" name="cnpjFornecedor"
                                            class="form-control" required>
                                        <div ng-messages="$ctrl.form.cnpjFornecedor.$error" ng-if="$ctrl.form.$submitted">
                                            <span class='help-block txt-color-red font-xs no-margin' ng-message="required">
                                                Informe um CNPJ para o fornecedor.
                                            </span>
                                            <span class='help-block txt-color-red font-xs no-margin' ng-message="cnpj">
                                                CNPJ informado é inválido.
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-xs-4 form-group">
                                        <label>Código do fornecedor</label>
                                        <input ng-model="$ctrl.codigo.codigoFornecedor" name="codigoFornecedor"
                                            class="form-control" required>
                                        <div ng-messages="$ctrl.form.codigoFornecedor.$error" ng-if="$ctrl.form.$submitted">
                                            <span class='help-block txt-color-red font-xs no-margin' ng-message="required">
                                                Informe o código do fornecedor.
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-xs-3 form-group">
                                        <label>&nbsp;</label>
                                        <promise-tracker promise="$ctrl.formPromise" active="isLoading">
                                            <button class="btn btn-primary btn-block" ng-disabled="isLoading">
                                                <span ng-if="!isLoading">Adicionar</span>
                                                <span ng-if="isLoading">Adicionando...</span>
                                            </button>
                                        </promise-tracker>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12" ng-if="$ctrl.produto.codigos.length">
                                        <table class="table table-hover no-margin">
                                            <thead>
                                                <tr>
                                                    <th>CNPJ do fornecedor</th>
                                                    <th>Código do fornecedor</th>
                                                    <th width="1">
                                                        <i class="fa fa-cogs"></i>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr ng-repeat="codigo in $ctrl.produto.codigos">
                                                    <td>{{codigo.cnpjFornecedor | cpfCnpj}}</td>
                                                    <td>{{codigo.codigoFornecedor}}</td>
                                                    <td>
                                                        <promise-tracker promise="codigo.promise" active="isRemoving">
                                                            <button type="button" class="btn btn-xs btn-default"
                                                                ng-disabled="isRemoving" ng-click="$ctrl.removerCodigo(codigo)">
                                                                <i class="fa fa-trash" ng-hide="isRemoving"></i>
                                                                <i class="fa fa-circle-o-notch fa-spin"
                                                                    ng-show="isRemoving"></i>
                                                            </button>
                                                        </promise-tracker>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div ng-show="$ctrl.produto.codigos && !$ctrl.produto.codigos.length">
                                        <highlighted>
                                            <main>Nenhum código de fornecedor cadastrado.</main>
                                            <secondary>Você pode cadastrar um código utilizando o formulário acima.</secondary>
                                        </highlighted>
                                    </div>
                                </div>
                            </div>
                            <a class="cursor-pointer" ng-hide="$ctrl.codigosSugeridos && !$ctrl.codigosSugeridos.length"  
                                data-toggle="collapse"
                                data-target="#sugestao-fornecedor">Sugestão de fornecedores</a>
                            <div id="sugestao-fornecedor" class="collapse">
                                <div>
                                    <div class="row">
                                        <div class="col-xs-12" ng-if="$ctrl.codigosSugeridos.length">
                                            <hr>
                                            <h4>Fornecedores Sugeridos</h4>
                                            <table class="table table-hover no-margin">
                                                <thead>
                                                    <tr>
                                                        <th>CNPJ do fornecedor</th>
                                                        <th>Código do fornecedor</th>
                                                        <th width="1">
                                                            <i class="fa fa-cogs"></i>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr ng-repeat="sugerido in $ctrl.codigosSugeridos">
                                                        <td>{{sugerido.cnpjFornecedor | cpfCnpj}}</td>
                                                        <td>{{sugerido.codigoFornecedor}}</td>
                                                        <td>
                                                            <promise-tracker promise="codigo.promise" active="isCreating">
                                                                <button type="button" class="btn btn-xs btn-default"
                                                                    ng-disabled="isCreating" ng-click="$ctrl.adicionarFornecedor(sugerido)">
                                                                    <i class="fa fa-plus" ng-hide="isCreating"></i>
                                                                    <i class="fa fa-circle-o-notch fa-spin"
                                                                        ng-show="isCreating"></i>
                                                                </button>
                                                            </promise-tracker>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </loading>
                </modal-body>
                <modal-footer>
                    <button class="btn btn-default" type="button" ng-click="$ctrl.onClose()">Fechar</button>
                </modal-footer>
            </modal>
        </form>
        `
    })
